export default __webpack_public_path__ + "static/media/proclamation9.b3241100.jpg";